import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import { useAuthState as useFirebaseAuthState } from "react-firebase-hooks/auth";
import type { UserContext } from "../auth/auth";
import { contextFromToken } from "../auth/auth";

export const useAuthState = () => {
  const [user, loading] = useFirebaseAuthState(getAuth());
  const [context, setContext] = useState<UserContext | null>(null);

  useEffect(() => {
    if (user) {
      user.getIdTokenResult().then((t) => setContext(contextFromToken(t)));
    } else {
      setContext(null);
    }
  }, [user]);

  return { loading, user, context };
};
